import { createSlice } from "@reduxjs/toolkit";
import { fetchStockOverview, fetchStockOverviewDetail } from "./thunk";

interface DistrictState {
  stockOverviewList: any[];
  currentStockOverviewDetail: any | null; // Added state for detail view
  rowCount: number;
  detailRowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: DistrictState = {
  stockOverviewList: [],
  currentStockOverviewDetail: null,
  rowCount: 0,
  detailRowCount: 0,
  loading: false,
  error: null,
};

const inventoryStockOverviewSlice = createSlice({
  name: "stockOverviewReducer",
  initialState,
  reducers: {
    clearStockOverview: (state) => {
      state.stockOverviewList = [];
      state.rowCount = 0;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStockOverview.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStockOverview.fulfilled, (state, action) => {
        state.loading = false;
        state.stockOverviewList = action.payload.data;
        state.rowCount = action.payload.rowCount;
        console.log("action.payload", action.payload);
      })
      .addCase(fetchStockOverview.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to fetch fetchStockOverview";
      })
      // Handle fetchStockOverviewDetail
      .addCase(fetchStockOverviewDetail.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.currentStockOverviewDetail = null;
      })
      .addCase(fetchStockOverviewDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.currentStockOverviewDetail = action.payload;
        state.detailRowCount = action.payload.rowCount;
      })
      .addCase(fetchStockOverviewDetail.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to fetch Stock Overview details";
      });
  },
});

export const { clearStockOverview } = inventoryStockOverviewSlice.actions;
export default inventoryStockOverviewSlice.reducer;
